import Finnance from '@/components/finnance/Finnance';
import PurchaseOrders from '@/components/finnance/purchaseOrders/PurchaseOrders'
import PurchaseOrdersForm from '@/components/finnance/purchaseOrders/PurchaseOrdersForm'
import Invoices from '@/components/finnance/invoices/Invoices'
import InvoiceForm from '@/components/finnance/invoices/InvoicesForm'

export default 		{
    path: '/finnance',
    component: Finnance,
    children: [
        {
            path: 'purchaseOrders',
            name: 'PurchaseOrders',
            component: PurchaseOrders,
        },
        {
            path: 'purchaseOrders/new',
            name: 'PurchaseOrdersNew',
            component: PurchaseOrdersForm
        },
        {
            path: 'purchaseOrders/edit/:purchaseOrderId',
            name: 'PurchaseOrdersEdit',
            component: PurchaseOrdersForm
        },
        {
            path: 'invoices',
            name: 'Invoices',
            component: Invoices
        },
        {
            path: 'invoices/new/:purchaseOrderId',
            name: 'InvoiceNew',
            component: InvoiceForm
        }
    ],
    meta: {requiresAuth: true}

}